import { EventEmitter, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const USER_ACCESS_SERVICE_TOKEN = new InjectionToken<IUserAccessService>('IUserAccessService');

export interface IUserAccessService {
  scopesChange: EventEmitter<void>;

  getSelectsData(appId: string): Observable<IUserAccessSelects>;
  getAllScopes(appId: string): Observable<IUserAccessScope[]>;

  createScope(appId: string, params: IUserAccessScope): Observable<IUserAccessScope>;
  editScope(appId: string, params: IUserAccessScope): Observable<IUserAccessScope>;
  deleteScope(appId: string, uuid: string): Observable<IUserAccessScope>;
}

export interface IUserAccessScope {
  description: string;
  exclude: string[];
  isShowRejectLeads: boolean;
  leadProfiles: ILeadProfiles[];
  scopeAdvertiserUuid: string[];
  scopeAffiliateId: string[];
  scopeConversionFields: string[];
  scopeHideNameFields: string[];
  scopeLeadFields: string[];
  scopeLeadLogFields: string[];
  scopeTermsUuid: string[];
  trafficProviderUuid: string;
  uuid: string;
  uuidUsers: string[];
  name?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ILeadProfiles {
  key: string;
  value: string[];
  exclude: boolean;
}

export interface IUserAccessDataResponse {
  data: {
    data: {
      selects: IUserAccessSelects;
    };
  };
  measure: number;
  measure_with_boot: number;
}

export interface IUserAccessSelects {
  advertisers: Record<string, string>;
  conversionFields: Record<string, string>;
  leadPushLogFields: Record<string, string>;
  hideNamesFields: Record<string, string>;
  leadFields: Record<string, string>;
  leadProfiles: Record<string, string>;
  terms: Record<string, string>;
  trafficProviders: { affiliates: Record<string, string>; name: string; uuid: string }[];
  users: {
    uuid: string;
    name: string;
    masterId: number;
  }[];
}
